import { defineStore } from 'pinia';
import actions from './actions';
import { createInitialState } from './state';
import getters from './getters';

export const useStore = defineStore('main', {
  state: () => createInitialState(),
  getters,
  actions,
});
